module.exports = "https://cdn.dove.it/_next/static/public/assets/services/visibilita-portali_340x200.d8ff9f8f1a5c51e9ebf39109d29af620.jpg";